import InfoBox from "@components/InfoBox/InfoBox";

export default function Header({ name, infoTitle, infoContent }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        // gap: "4px",
        height: "20px",
      }}
    >
      {name}
      <InfoBox infoTitle={infoTitle} infoContent={infoContent} />
    </div>
  );
}
